import { render, staticRenderFns } from "./Prediction.vue?vue&type=template&id=174fef2d&scoped=true&"
import script from "./Prediction.vue?vue&type=script&lang=js&"
export * from "./Prediction.vue?vue&type=script&lang=js&"
import style0 from "./Prediction.vue?vue&type=style&index=0&id=174fef2d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174fef2d",
  null
  
)

export default component.exports